import { useLayoutEffect, useState, type ReactNode } from 'react';
import { createPortal } from 'react-dom';

import { usePageContentSidebar } from '#providers/page-layout-provider';

/**
 * Declarative bridge: children portaled into {@link PageContentSidebar}’s mount node.
 * Re-renders after layout so `contentSidebarRef` is populated (refs are not set during the first render pass).
 */
export function PageContentSidebarPortal({
  children,
}: {
  children: ReactNode;
}) {
  const { contentSidebarRef } = usePageContentSidebar();
  const [, setPortalGeneration] = useState(0);

  useLayoutEffect(() => {
    setPortalGeneration((g) => g + 1);
  }, []);

  const target = contentSidebarRef.current;
  if (children == null || !target) {
    return null;
  }

  return createPortal(children, target);
}
